import { actions, state as stateConstants } from 'src/constants';
import { config } from 'src/constants';
import api from 'src/core/api';

import { getActionType } from './helper';

const { IDENTIFIER_TYPE_LIST, IDENTIFIER_TYPE_DETAILS, IDENTIFIER_TYPE_ITEM } =
  stateConstants;

export const getList =
  (Model, identifier) =>
  (payload, meta = {}) => {
    const actionType = getActionType(
      actions.ACTION_GET,
      Model.NAME,
      identifier || IDENTIFIER_TYPE_LIST
    );

    // const fullPayload = {
    //   pageNumber: 0,
    //   pageSize: 0,
    //   customProductCategory: 0,
    //   productCategoryFormat: 0,
    //   searchKey: 'string',
    //   sortBy: 'string',
    //   sortOrder: 'string',
    //   fromDate: 'string',
    //   toDate: 'string',
    //   status: 'string',
    // };

    const dateToUTC = (dateType, dateString) => {
      if (!dateString) return '';
      const date = new Date(dateString);
      if (dateType === 'startDate' || dateType === 'startRange')
        return date?.toISOString();
      if (dateType === 'endDate' || dateType === 'endRange') {
        date.setHours(23, 59, 59, 999);
        return date?.toISOString();
      }
    };

    const postPayload = {
      pageNumber: payload?.pagination?.currentPage || '',
      pageSize: payload?.pagination?.pageInterval || '',
      customProductCategory: payload?.customProductCategory || '',
      productCategoryFormat: payload?.productCategoryFormat || '',
      searchKey: payload?.searchText || '',
      sortBy: payload?.sortBy || '',
      sortOrder: payload?.sortOrder || '',
      fromDate:
        dateToUTC('startDate', payload?.filter?.startDate) ||
        dateToUTC('startRange', payload?.filter?.startRange) ||
        '',
      toDate:
        dateToUTC('endDate', payload?.filter?.endDate) ||
        dateToUTC('endRange', payload?.filter?.endRange) ||
        '',
      status: payload?.filter?.status || '',
    };
    const { url, dataPath } = Model.getListConfig(payload);
    let options = {};
    if (Model.NAME === 'user') {
      options = { ...api.http.get(), dataPath };
    } else {
      options = { ...api.http.post(postPayload), dataPath };
    }

    return api.request(actionType, url, options, meta);
  };

export const getDetails =
  (resource, identifier = IDENTIFIER_TYPE_DETAILS, config) =>
  (payload, meta = {}) => {
    const apiConfig = config || resource.getDetailsConfig(payload);

    const actionType = getActionType(
      actions.ACTION_GET,
      resource.NAME,
      identifier
    );
    const { url, dataPath } = apiConfig;
    const options = { ...api.http.get(), dataPath };

    return api.request(actionType, url, options, meta);
  };

export const deleteResource =
  (resource) =>
  (payload, meta = {}) => {
    // unfortunately apis don't support delete so post is used to delete
    // send body = data where data = { resourceId : id }
    // Example:
    // - delete a credit card means data = { userCreditCardId: 1 }

    const actionType = getActionType(
      actions.ACTION_DELETE,
      resource.NAME,
      IDENTIFIER_TYPE_ITEM
    );
    const { url } = resource.getDeleteConfig(payload);
    const options = api.http.post(payload);

    return api.request(actionType, url, options, meta);
  };

export const createResource =
  (resource, customAction) =>
  (payload, meta = {}) => {
    const action = customAction || actions.ACTION_CREATE;
    const actionType = getActionType(
      action,
      resource.NAME,
      IDENTIFIER_TYPE_ITEM
    );
    const options = { ...api.http.post(payload), requestId: meta.requestId };

    return api.request(actionType, meta.url, options, meta, payload);
  };

export const updateResource =
  (resource) =>
  (payload, meta = {}) => {
    const actionType = getActionType(
      actions.ACTION_UPDATE,
      resource.NAME,
      IDENTIFIER_TYPE_ITEM
    );
    const config = resource.getUpdateConfig ? resource.getUpdateConfig() : meta;

    const { url, dataPath } = config;
    const options = { ...api.http.post(payload), dataPath };

    return api.request(actionType, url, options, meta);
  };

export const getCustomDesignDetails = async (payload) => {
  const queryParams = new URLSearchParams({
    batchId: payload.batchId,
    customProductCategory: payload.customProductCategory,
    productCategoryFormat: payload.productCategoryFormat,
    lineItem: payload.lineItem,
  });

  const url = `/mcp/get-custom-design?${queryParams}`;
  const apiUrl = `${config.serviceUrl}${url}`;

  try {
    const response = await fetch(apiUrl, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      throw await response.json();
    }
    const data = await response.json();
    return data;
  } catch (error) {
    console.log('Error fetching custom design:', error);
    throw error;
  }
};
